import React from 'react';
import VideoCard from './VideoCard';
import { Grid } from '@chakra-ui/react';

interface Props {
  videos: any;
}

const VideoGrid: React.FC<Props> = ({videos}: Props) => {
  //console.log(videos);
  return (
    <Grid templateColumns='repeat(3, 1fr)' gap={4}>
      {videos.map((video: any, index: any): any => (
        <VideoCard
          key={index}
          videoTitle={video.fields.title}
          videoImage={video.fields.image.fields.file.url}
          videoDescription={video.fields.description}
          videoLink={video.fields.externalUrl}
        />
      ))}
    </Grid>
  );
}

export default VideoGrid;
